<template>
    <div>
        <ui-procedure-modal :id="id" :guide="guide" inline @submit="procedureSelectedHandler" />
    </div>
</template>

<script>
    import uiProcedureModal from '@/components/ui-facilita/procedure-modal'

    import { deal } from '@/services/axios'
    
    import helpers from '@/mixins/helpers'

    export default {
        name: 'sales-procedures',
        
        components: {
            uiProcedureModal,
        },

        mixins: [helpers],

        props: {
            /**
			 * Propriedade referente ao ID do cliente, para se buscar os
			 * procedimentos
			 */
			id: {
				type: [String, Number],
				required: true
			},

			/**
			 * Propriedade que identifica qual guia está acessando a tela de procedimentos
			 */
			guide: {
				type: String,
				required: true
			}
        },

        mounted() {
            this.$root.$emit('modal-open-sales-procedure')
        },
        
        methods: {
            /**
             * Evento disparado ao selecionar o procedimento e quando o modal de fecha
             */
            procedureSelectedHandler(value) {
                deal.update(value.deal, '/procedure', { button_id: value.procedure })
                    .then(response => {
                        if (response.data && response.data.msg) this.$toastr.s(response.data.msg)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                    })
                    .finally(() => {
                        this.oldPanelLinkButton(`/vendas/negocios/${value.deal}`)
                    })
            },
        },
    }
</script>

<style lang="stylus" scoped>

</style>